export class Category {

    public id: string = "0";
    public name: string;
    public documents: string;
    public documents_en: string;
    
    constructor() {}
}